import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=3eca7188&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=3eca7188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eca7188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eca7188')) {
      api.createRecord('3eca7188', component.options)
    } else {
      api.reload('3eca7188', component.options)
    }
    module.hot.accept("./SideBar.vue?vue&type=template&id=3eca7188&scoped=true&", function () {
      api.rerender('3eca7188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SideBar.vue"
export default component.exports